import { render, staticRenderFns } from "./MultiLineText.vue?vue&type=template&id=95af0522&scoped=true&"
import script from "./MultiLineText.vue?vue&type=script&lang=js&"
export * from "./MultiLineText.vue?vue&type=script&lang=js&"
import style0 from "./MultiLineText.vue?vue&type=style&index=0&id=95af0522&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95af0522",
  null
  
)

export default component.exports